import React from "react";
import { white } from "assets/styleUtils";
import { Header } from "components";
import { x } from "assets";

export default function InfoModal({
  content,
  closePopupToday,
  close,
}: {
  content: React.ReactNode;
  closePopupToday?: () => void;
  close?: () => void;
}) {
  return (
    <div
      style={{
        width: "330px",
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -130%)",
        zIndex: 300,
      }}
    >
      <div
        style={{
          backgroundColor: white,
        }}
      >
        <Header
          isVisible={true}
          title="안내사항"
          right={{
            onClick: close,
            icon: x,
          }}
        />
        <div
          style={{
            overflowY: "scroll",
            height: "400px",
            padding: "60px 10px",
          }}
        >
          {content}
        </div>
      </div>
      <div
        onClick={closePopupToday}
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "flex-end",
          color: white,
          fontSize: "14px",
          fontWeight: 500,
          cursor: "pointer",
        }}
      >
        오늘 하루 보지 않기
      </div>
    </div>
  );
}
